<template>
  <div>
    <div v-responsive.lg.xl>
      <desktop
        v-model="login"
        :error="error"
        :config="config"
        :processing="processing"
        @do_auth="do_auth"
      />
    </div>
    <div v-responsive.md>
      <tablet
        v-model="login"
        :error="error"
        :config="config"
        :processing="processing"
        @do_auth="do_auth"
      />
    </div>
    <div v-responsive.sm.xs>
      <smartphone
        v-model="login"
        :error="error"
        :config="config"
        :processing="processing"
        @do_auth="do_auth"
      />
    </div>
  </div>
</template>

<script>
// import "../assets/auth/vendor/bootstrap/css/bootstrap.min.css";
import "../assets/auth/css/util.css";
import "../assets/auth/css/main.css";
// import sha1 from "js-sha1";
import { local_api } from "../utils";

import Desktop from "./login/Desktop.vue";
import Tablet from "./login/Tablet.vue";
import Smartphone from "./login/Smartphone.vue";

export default {
  name: "Login",
  components: { Desktop, Tablet, Smartphone },
  data() {
    return {
      login: {
        enterprise: "",
        username: "",
        password: "",
      },
      error: "",
      processing: false,
      config: {
        hide_enterprise_field: false,
        default_enterprise: "",
        logo: "",
      },
    };
  },
  created() {
    let vm = this;
    local_api(vm, "post", "/auth/do-get-config", {})
      .then(function (response) {
        if (response) {
          let config = JSON.parse(response);
          vm.config = config;
          vm.login.enterprise = vm.config.default_enterprise;
        }
      })
      .catch(function (err) {
        vm.error = err;
      })
      .finally(() => {
        vm.processing = false;
      });
  },
  mounted() {
    let vm = this;
    if (process.env.NODE_ENV == "development") {
      vm.login.enterprise = "ctrlp";
      vm.login.username = "lr";
      vm.login.password = "admin";
    }
    let sessionExists = vm.$session.exists();
    if (sessionExists) vm.$router.replace({ name: "Home" });
  },
  methods: {
    do_auth() {
      let vm = this;
      this.processing = true;
      local_api(this, "post", "/auth/do-auth", {
        e: this.login.enterprise,
        u: this.login.username,
        p: this.login.password,
        // p: sha1(this.password),
      })
        .then(function (response) {
          if (!response) vm.error = vm.$t("invalid authentication");
          else {
            let enterprise_setup = response.enterprise_settings;
            // Set default values for enterprise setup
            if (!enterprise_setup.simple_date_format)
              enterprise_setup.simple_date_format = "DD/MM/YYYY";
            if (!enterprise_setup.detailed_date_format)
              enterprise_setup.detailed_date_format = "DD/MM/YYYY HH:mm";
            if (!enterprise_setup.second_detailed_date_format)
              enterprise_setup.second_detailed_date_format =
                "DD/MM/YYYY HH:mm:ss";
            if (!enterprise_setup.currency) enterprise_setup.currency = "Q";

            vm.$emit("update_nav", response.user);
            vm.$emit("switch_nav", { type: "modul", data: response.user });
            vm.$session.start();
            vm.$session.set("login_type", "modul");
            vm.$session.set("token", response.token);
            vm.$session.set("user", response.user);
            vm.$session.set("enterprise_setup", enterprise_setup);
            //this.$session.set('jwt', response.body.token)

            /** Check for commanded redirections */
            let shouldRedirect = vm.$route.query.redirect;
            console.log("shouldRedirect", shouldRedirect);
            if (shouldRedirect) {
              window.location = `${window.location.origin}/#/${shouldRedirect}`;
            } else {
              /**
             Role based redirection
             */
              if (response.user.roles) {
                let trgtRedirectRole = response.user.roles.find((r) => {
                  return r.login_redirect_to;
                });
                if (trgtRedirectRole) {
                  vm.$router.replace({
                    name: trgtRedirectRole.login_redirect_to,
                  });
                } else {
                  vm.$router.replace({ name: "Home" });
                }
              } else {
                vm.$router.replace({ name: "Home" });
              }
            }
          }
        })
        .catch(function (err) {
          vm.error = err;
        })
        .finally(() => {
          this.processing = false;
        });
    },
  },
};
</script>

<style>
.wrap-login100 {
  padding: 0;
}
</style>
